import { EDRAWMAX_PRODUCT_ENV, EDRAWMAX_PRODUCT_API, EDRAWMAX_HELP_URL } from "@/env/";

let temp = typeof window !== "undefined" ? !~location.host.indexOf("edrawmax.com") : true;
if (process.env.NODE_ENV === "development") {
    temp = process.env.VUE_APP_LANGUAGE === "zh";
} else {
    temp = window.GLOBAL.DEPLOY_TYPE === "cn";
}

export var internal = temp;
var urls = internal
    ? {
          userUrl: "https://userapi.edrawsoft.cn",
          apiUrl: "https://maxapi.edrawsoft.cn",

          // OSS地址。【配置已废弃，改成从接口获取并设置在全局变量中】
          //   fileOssUrl: "https://edrawcloudcn.oss-cn-shenzhen.aliyuncs.com/",
          //   assetsOssUrl: "https://edrawcloudpubliccn.oss-cn-shenzhen.aliyuncs.com/",

          //账户中心
          accountUrl: "https://account.edrawsoft.cn",
          goApiUrl: "https://goapi.edrawsoft.cn",
          edrawmaxApi: "https://api.edrawmax.cn",

          //反馈中心
          feedbackUrl: "https://www.edrawmax.cn/feedback/web/help/",
          helpcenterUrl: "https://api.pixso.design/",
          masterURL: "https://masterapi.edrawsoft.cn/", // wucc：max项目中只有审核发送消息用到了masterapi，目前审核后台关闭了
      }
    : {
          userUrl: "https://userapi.edrawsoft.com",
          apiUrl: "https://maxapi.edrawsoft.com",

          // OSS地址。【配置已废弃，改成从接口获取并设置在全局变量中】
          //   fileOssUrl: "https://edrawcloudus.s3.amazonaws.com/",
          //   assetsOssUrl: "https://edrawcloudpublicus.s3.amazonaws.com/",

          //账户中心
          accountUrl: "https://account.edrawsoft.com",
          goApiUrl: "https://api.edrawsoft.com", // "https://dev.edrawsoft.com",
          edrawmaxApi: "https://api.edrawmax.com", // "https://dev.edrawmax.com"

          //反馈中心
          feedbackUrl: "https://www.edrawmax.com/feedback/web/help/",
      };

if (process.env.NODE_ENV === "development") {
    if (internal) {
        urls.userUrl = "https://dev-userapi.edrawsoft.cn";
        urls.apiUrl = "https://dev-maxapi.edrawsoft.cn";
        urls.accountUrl = "https://dev-account.edrawsoft.cn";
        urls.goApiUrl = "https://dev-goapi.edrawsoft.cn";
        urls.edrawmaxApi = "https://dev.edrawmax.cn";
    } else {
        urls.userUrl = "https://dev-userapi.edrawsoft.com";
        urls.apiUrl = "https://dev-maxapi.edrawsoft.com";
        urls.accountUrl = "https://dev-account.edrawsoft.com";
        urls.goApiUrl = "https://dev-goapi.edrawsoft.com";
        urls.edrawmaxApi = "https://dev.edrawmax.com";
    }
}
// 容器化部署时，主要的接口取 html 中注入的值
if (process.env.NODE_ENV === "production") {
    urls.userUrl = window.GLOBAL.HTTP_API_EDRAW_USER_BASE;
    urls.apiUrl = window.GLOBAL.HTTP_API_PHP_BASE;
    urls.accountUrl = window.GLOBAL.HTTP_ACCOUNT_BASE;
    urls.goApiUrl = window.GLOBAL.HTTP_API_EDRAW_GO_BASE;
    urls.edrawmaxApi = window.GLOBAL.HTTP_API_GO_BASE;
}

if (EDRAWMAX_PRODUCT_ENV === "private" || EDRAWMAX_PRODUCT_ENV === "workwx") {
    urls.userUrl = EDRAWMAX_PRODUCT_API;
    urls.apiUrl = EDRAWMAX_PRODUCT_API;
    urls.helpcenterUrl = EDRAWMAX_HELP_URL;
}

export { urls };
